import clsx from "clsx";
import { SubscriptionRefillModal } from "components/billing/subscription-refill-modal";
import React, { useState } from "react";
import { useAppSelector } from "store";
import { authNewSelectors } from "store/reducers/auth-new";

import css from "./type.module.scss";

const SubscriptionCreditLow = () => {
  const [show, showSet] = useState(false);
  const creditLeft = useAppSelector(authNewSelectors.creditLeftGet);

  return (
    <div className={clsx(css.wrapper, css.yellow)}>
      <div className={css.content}>
        <a className={css.link} onClick={() => showSet(true)}>
          You're {creditLeft === 0 ? "" : "running"} out of credits.{" "}
          <strong>Restart your billing cycle now</strong>.
        </a>
      </div>
      {show && <SubscriptionRefillModal onClose={() => showSet(false)} />}
    </div>
  );
};

export default SubscriptionCreditLow;
